var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mgifts--item",class:{ extended: _vm.extended }},[_c('div',{staticClass:"mgifts--item__img"},[_c('img',{attrs:{"src":_vm.gift.photo,"alt":_vm.gift.description}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }